import React from 'react';
import './App.css';
import Common from './common';

function App() {
  return (
    <div className="App-header">
       <Common />
    </div>
  );
}

export default App;
